import { t, getCurrentLocale } from '../plugins/i18n'
import type { AppLocale } from '../plugins/i18n'

const localeToIntl: Record<AppLocale, string> = {
    cs: 'cs-CZ',
    sk: 'sk-SK',
    en: 'en-US',
    de: 'de-DE',
    'de-ch': 'de-CH',
    pl: 'pl-PL',
    fi: 'fi-FI',
    sv: 'sv-SE',
    da: 'da-DK',
}

// Funkce pro formátování data, která vrací "dnes" pro dnešní datum a "zítra" pro zítřejší
export const formatDate = (date?: Date | string, dateTo?: Date | string): string => {
    if (!date) return ''; // Ověříme, zda existuje datum

    const parsedDate = new Date(date);
    const parsedDateTo = dateTo ? new Date(dateTo) : null;
    const now = new Date();
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1); // Nastavíme zítřejší datum

    const isSameDay = (date1: Date, date2: Date): boolean => {
        return date1.getFullYear() === date2.getFullYear() &&
               date1.getMonth() === date2.getMonth() &&
               date1.getDate() === date2.getDate();
    };

    const dayKeys = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'] as const;
    const dayOfWeek = t(`dateFormat.${dayKeys[parsedDate.getDay()]}`);

    // Podmínka pro "Do kabiny!" pokud je 30 minut před začátkem
    const thirtyMinutesBefore = new Date(parsedDate.getTime() - 30 * 60 * 1000);
    if (now >= thirtyMinutesBefore && now < parsedDate) {
        return t('dateFormat.lockerRoom');
    }

    // Pokud je dateTo k dispozici a aktuální čas je mezi date a dateTo
    if (parsedDateTo && now >= parsedDate && now <= parsedDateTo) {
        return t('dateFormat.now');
    }

    // Pokud dateTo uplynulo
    if (parsedDateTo && now > parsedDateTo) {
        return t('dateFormat.played');
    }

    if (isSameDay(parsedDate, today)) {
        return t('dateFormat.today');
    } else if (isSameDay(parsedDate, tomorrow)) {
        return t('dateFormat.tomorrow');
    } else {
        const intlLocale = localeToIntl[getCurrentLocale()] || 'cs-CZ';
        return `${dayOfWeek} ${parsedDate.toLocaleDateString(intlLocale, {
            day: 'numeric',
            month: 'numeric',
        })}`;
    }
};



// Funkce pro formátování datumu ve formátu YYYY-MM-DD
export const formatDateForPicker = (dateString: string | null) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Měsíc je 0-indexován
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };


  export const formatPlayEventTime = (
    rawTime: number,
    partsCount: number | null,
    partDuration: number | null,
    splitPartIndex?: number | null
  ) => {
    // Převod rawTime do formátu mm:ss
    const minutes = Math.floor(rawTime / 60);
    const seconds = rawTime % 60;
    const timeString = `${String(minutes).padStart(2, '0')}:${String(
      seconds
    ).padStart(2, '0')}`;
  
    let partSign = '';
    let partNumber: number | null = null;
  
    // Split mode: partSign = (partIndex+1)/partsCount
    if (splitPartIndex != null && partsCount !== null) {
      partNumber = splitPartIndex + 1;
      partSign = `${partNumber}/${partsCount}`;
    } else if (partsCount !== null && partDuration !== null) {
      const totalGameTime = partsCount * partDuration;
  
      // Pokud je rawTime větší nebo roven celkové regulérní době,
      // jde o prodloužení – partSign bude 'PP'
      if (rawTime >= totalGameTime) {
        partSign = 'PP';
        // Zde můžeme nastavit partNumber jako maximální počet částí,
        // nebo jinak dle požadované logiky pro prodloužení.
        partNumber = partsCount;
      } else {
        // Výpočet aktuální části, počítáme: index = (rawTime / partDuration) zaokrouhleno dolů + 1
        partNumber = Math.floor(rawTime / partDuration) + 1;
        partSign = `${partNumber}/${partsCount}`;
      }
    }
  
    return {
      time: rawTime,
      timeString,
      partSign,
      partNumber,
    };
  };
  